export var EMenuTab;
(function (EMenuTab) {
    EMenuTab[EMenuTab["\u8BA2\u8D27\u5355"] = 25] = "\u8BA2\u8D27\u5355";
    EMenuTab[EMenuTab["\u5165\u5E93\u5355"] = 26] = "\u5165\u5E93\u5355";
    EMenuTab[EMenuTab["\u9000\u8D27\u5355"] = 27] = "\u9000\u8D27\u5355";
    EMenuTab[EMenuTab["\u5BA2\u6237\u5BF9\u8D26\u5355"] = 68] = "\u5BA2\u6237\u5BF9\u8D26\u5355";
    EMenuTab[EMenuTab["\u5BA2\u6237\u4ED8\u6B3E\u5355"] = 76] = "\u5BA2\u6237\u4ED8\u6B3E\u5355";
})(EMenuTab || (EMenuTab = {}));
export default EMenuTab;
